<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative">
        <div id="eot">


            <my-evidence />

        </div>
    </div>
</template>

<script>
    import myEvidence from "./myEvidence";
    import myTort from "./myTort";
    export default {
      metaInfo: {
        title: '网页取证|前海版权综合服务平台',
        meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        }, {
          name: 'Description',
          content: '会员信息,前海版权服务平台,人人都是创作者，人人都是版权人。前海版权服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
      },
        name: "evidenceAndTort",
        components:{
            myEvidence,myTort
        },
        data(){
          return{
              flag:true
          }
        }
    }
</script>

<style lang="less" scoped>
    #eot{
        /*min-width: 1334px;*/
        min-height: 550px;
        /*background: #d81e06;*/
        .eot_title{
            display: flex;
            .item{
                position: relative;
                margin-right: 26px;
                a{
                    width:42px;
                    height:14px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:21px;

                    &:hover {
                        color:rgba(16,16,16,1);
                        &:before{
                            content:'';
                            background:transparent;
                            width:42px;
                            height: 1px;
                            position: absolute;
                            left:0;
                            bottom:20px;
                        }
                    }
                }
                .active{
                    color:rgba(16,16,16,1);
                }
                .active:before{
                    content:'';
                    background:rgba(255,216,0,1);
                    width:100%;
                    height: 2px;
                    position: absolute;
                    left:0;
                    bottom:-5px;
                }
            }

        }
    }

</style>
